import React from "react";
import Autocomplete from "react-google-autocomplete";
import { useController, UseControllerProps } from "react-hook-form";
import { NEXT_PUBLIC_GOOGLE_MAPS_API_KEY } from '../../../utils/config'

function InputPlace(props: UseControllerProps<any> & {
    label?: string,
    className?: string,
    onChange?: (t:any) => void
    onPlaceSelected?: (t:any, r?: any) => void
    value?: any
    ref?: any
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}) {

    let { label = '', onChange, onPlaceSelected, value, onKeyDown, ref } = props;
    const { field, fieldState } = useController(props);

    return <div className=' border border-[#EAEDEE] rounded-[22px] overflow-hidden'>
        <label className="relative h-[48px] block bg-white"  id='search_inp_con'>
            <Autocomplete
                ref={ref}
                defaultValue={value}
                className="absolute fuck-autofill appearance-none bottom-0 w-full h-[48px] outline-none text-black  bg-opacity-0 pl-[18px] pr-[100px]"
                placeholder={label}
                language='en'
                apiKey={NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
                onPlaceSelected={(place: any, r) => {
                    if (place?.formatted_address) {
                        onPlaceSelected && onPlaceSelected(place?.formatted_address)
                    }
                }}
                onChange={e => onChange && onChange(e)}
                onSelect={e => onChange && onChange(e)}
                onBlur={(e:any) => {
                    field.onBlur()
                }}
                onKeyDown={onKeyDown}
                options={{
                    types: ['address'],
                }}
            />
        </label>
        {fieldState.error ? <p className=" text-ms leading-3 mt-2 text-red pl-3">{fieldState.error?.message}</p> : null}
    </div>
}

export default (InputPlace);